import { IconProps } from '@chakra-ui/react';
import { PlatformInstagramColorIcon } from 'ui-components/dist/PlatformInstagramColorIcon';
import { PlatformSnapchatColorIcon } from 'ui-components/dist/PlatformSnapchatColorIcon';
import { PlatformTikTokColorIcon } from 'ui-components/dist/PlatformTikTokColorIcon';
import { PlatformYouTubeColorIcon } from 'ui-components/dist/PlatformYouTubeColorIcon';
import { PARTIALLY_SUPPORTED_PLATFORMS, SOCIAL_PLATFORMS } from '~/constants';

interface Props extends IconProps {
  platform: SOCIAL_PLATFORMS | PARTIALLY_SUPPORTED_PLATFORMS;
}

export const SocialPlatformIcon: React.FC<Props> = ({
  platform,
  ...iconProps
}) => {
  const component = {
    [SOCIAL_PLATFORMS.instagram]: PlatformInstagramColorIcon,
    [SOCIAL_PLATFORMS.tiktok]: PlatformTikTokColorIcon,
    [SOCIAL_PLATFORMS.youtube]: PlatformYouTubeColorIcon,
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: PlatformSnapchatColorIcon,
  };
  const PlatformIcon = component[platform];

  if (!PlatformIcon) {
    // eslint-disable-next-line no-console
    console.error(
      `There is no matching icon defined for the social platform "${platform}".`,
    );

    return null;
  }

  return <PlatformIcon {...iconProps} />;
};
